import { CCSplit } from './cc-split';
import { CreditCardUtility } from './credit-card-utility';

export class CCInfo {
    constructor() {
        this.cc_first_name_on_card = '';
        this.cc_last_name_on_card = '';
        this.cc_zip = '';
        this.cc_card_number = '';
        this.cc_expiration_month = null;
        this.cc_expiration_year = null;
        this.cc_cvv = '';
        this.payment_amount = 0;
    }

    bSwiped: boolean;
    messageMode: string;

    cc_first_name_on_card: string;
    cc_last_name_on_card: string;
    cc_address: string;
    cc_city: string;
    cc_state: string;
    cc_zip: string;
    cc_card_number: string;
    cc_expiration_month: number;
    cc_expiration_year: number;
    cc_cvv: string;
    cc_email: string;
    cc_phone_number: string;
    pay_token_type: 'APPLE' | 'GOOGLE' | undefined;
    pay_token: string;

    payment_source_code: string;

  split: CCSplit[] = [];
  plus_fee: number = 0;

    /*
    cc_processing_fee_percentage: number;
    add_processing_fee = false;
    tier: number;
    tier_fee: number;
    round_processing_fee = false;
    fee_rounding_threshold: number;
    round_processing_fee_digits: number;
    mininum_processing_fee = 0;
    maximum_processing_fee = 999;
*/
    // payment amount without processing charge
    payment_amount: number;

    /*
    get processing_charge_old(): number {
        if (this.cc_processing_fee_percentage == null) {
            return 0;
        }
        if (!this.cc_processing_fee_percentage) {
            return 0;
        }
        let processing_charge_total = 0;
        if (this.add_processing_fee) {
            processing_charge_total = this.payment_amount * (this.cc_processing_fee_percentage / 100);
            processing_charge_total = Math.round(processing_charge_total * 100) / 100;
        }
        return processing_charge_total;
    }
*/

    /*
    get processing_charge(): number {
        if (this.payment_amount === 0) {
            return 0;
        }

        let processing_charge_total = 0;
        if (this.tier && this.tier_fee && this.payment_amount <= this.tier) {
            processing_charge_total = this.tier_fee;
        } else {
            processing_charge_total = this.payment_amount * (this.cc_processing_fee_percentage / 100);
        }

        if (this.fee_rounding_threshold && this.round_processing_fee_digits) {
            return 0;
        }

        if (this.round_processing_fee) {
            if (this.fee_rounding_threshold) {
                const fraction = processing_charge_total - Math.trunc(processing_charge_total);
                if (fraction <= this.fee_rounding_threshold) {
                    processing_charge_total = Math.trunc(processing_charge_total);
                } else {
                    processing_charge_total = Math.trunc(processing_charge_total) + 1;
                }
            }

            if (this.round_processing_fee_digits > 0 && !this.fee_rounding_threshold) {
                processing_charge_total =
                    Math.round(processing_charge_total * (this.round_processing_fee_digits * 10)) /
                    (this.round_processing_fee_digits * 10);
            } else {
                processing_charge_total = Math.round(processing_charge_total);
            }
        }

        if (processing_charge_total < this.mininum_processing_fee) {
            processing_charge_total = this.mininum_processing_fee;
        }
        return processing_charge_total;
    }
*/

    get processing_charge(): number {
        let amount = 0;
        this.split.forEach((r) => {
            amount += r.processing_charge;
        });

        return amount + this.plus_fee;
    }

    // amount + processing fee
    // not used on server
    get payment_with_fee() {
        return this.payment_amount + this.processing_charge;
    }

    // Validation
    get cvvFormat() {
        return CreditCardUtility.CardInfo(this.cc_card_number).cvvFormat;
    }

    get cvvHint() {
        return CreditCardUtility.CardInfo(this.cc_card_number).cvvHelpText;
    }

    /*
    setFee(cc_processing_fee_percentage: number, add_processing_fee: boolean) {
        this.cc_processing_fee_percentage = cc_processing_fee_percentage;
        this.add_processing_fee = add_processing_fee;
    }
    */
}
